'use strict';

export default angular
  .module('maestro.filters.userDescription', [])

  .filter('userDescription', function($filter, utils) {
    return function(user) {
      if (user) {
        if (user.phone) {
          return utils.formatPhoneNumber(user.phone, user.phoneType);
        } else if (user.email && user.email.email) {
          return user.email.email;
        }
      }
      return '';
    };
  })
  .name;
